import React from 'react'
import './Wishlist.css'
import { Button, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { TbHeartPlus } from 'react-icons/tb'

function NoWishlistItems() {
    return (
        <div>
            <section className="pricing-list-section container py-5" id="bucket">
                <Container>
                    <div
                        className="empty-bag"
                        style={{
                            height: "20vh",
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center",
                            justifyContent: "center",
                            alignItems: 'center'
                        }}
                    >
                        <div className="empty-img">
                            <img src="./images/empty.png" alt="" width="15%" />
                        </div>
                        <div className='w-100'>
                            <h5 className="f24 fw-bold lh-1 mb-3 blue">
                                Your Wishlist is Currently Empty!
                            </h5>
                            <p className="f14 text-center">
                                You can click on <TbHeartPlus size={20} color='#CC0001' /> to save it under wishlist. Click below to go back to home
                            </p>
                            <div className="d-grid gap-2 d-md-flex justify-content-center align-items-center">
                                <a
                                    href="/"
                                >
                                    <Button style={{ borderColor: '#CC0001', borderWidth: '1px', background: '#CC0001' }}
                                        type='submit'
                                        className='d-flex justify-content-center align-items-center rounded-5'
                                    >
                                        Take me to home
                                    </Button>
                                </a>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </div>
    )
}

export default NoWishlistItems
